import { Badge, Text, useToast } from '@chakra-ui/react'
import { TableBuild } from 'components/organisms'
import { TableBuildProps } from 'components/organisms/TableBuild/interfaces'
import { TableBuildActionsType } from 'components/organisms/TableBuild/type'
import { useContractContext } from 'contexts/contract'
import { ContractLoteDTO } from 'models'
import { useEffect, useState } from 'react'
import formatter from 'utils/formatter'
import { TableTypeLote } from '../types'
import { variablesByType } from './constants'
import { LoteProps } from './interface'

export const Lotes: React.FC<LoteProps> = ({
    dataLote,
    pageNumber,
    limit,
    page,
    filter,
    handleLimitLote,
    handlePageLote,
    handleModalLote,
    type = 'contract'
}) => {
    const toast = useToast()
    const indexTab = type === 'contract' ? 1 : 2
    const { loadingLote, getLoteFile } = useContractContext()
    const { header } = variablesByType(type)

    const [orderBy, setOrderBy] = useState({
        ordenacao: 'nomeArquivo',
        tipoOrdenacao: 'ASC'
    })

    // const handleOrderBy = (ordenacao: TableTypeLote) => {
    //     setLoadingLote(true)
    //     setOrderBy(old => ({
    //         ordenacao,
    //         tipoOrdenacao:
    //             old.ordenacao !== ordenacao
    //                 ? old.tipoOrdenacao
    //                 : old.tipoOrdenacao === 'ASC'
    //                 ? 'DESC'
    //                 : 'ASC'
    //     }))
    // }

    const colorBadge: { [key: string]: string } = {
        PROCESSADO: 'primary',
        PROCESSANDO: 'lime',
        AGUARDANDO: 'grayscale'
    }

    const colorBadgeFont: { [key: string]: string } = {
        PROCESSADO: 'white',
        PROCESSANDO: 'black',
        AGUARDANDO: '#888891'
    }

    const buildTable = (lote: ContractLoteDTO[]) => {
        return lote.map(
            ({
                nomeArquivo,
                dataInicio,
                dataFim,
                tamanho,
                status,
                contentType,
                guid,
                totalRegistros,
                totalRegistrosProcessados,
                dataCriacao,
                ...lote
            }) => ({
                ...lote,
                id: guid,
                lote: (
                    <Text minW="100px" whiteSpace={'break-spaces'}>
                        {nomeArquivo}
                    </Text>
                ),
                dataUpload: (
                    <Text
                        maxW="112px"
                        whiteSpace={'break-spaces'}
                        margin="0 38px 0 0"
                    >
                        {formatter.dataWithHour(dataInicio)}
                    </Text>
                ),
                processado: (
                    <Text
                        maxW="112px"
                        whiteSpace={'break-spaces'}
                        margin="0 38px 0 0"
                    >
                        {dataFim ? formatter.dataWithHour(dataFim) : ' - '}
                    </Text>
                ),
                dataCriacao: (
                    <Text
                        maxW="112px"
                        whiteSpace={'break-spaces'}
                        margin="0 38px 0 0"
                    >
                        {dataCriacao
                            ? formatter.dataWithHour(dataCriacao)
                            : ' - '}
                    </Text>
                ),

                contratos: totalRegistros ? totalRegistros : '-',
                processados: totalRegistrosProcessados
                    ? totalRegistrosProcessados
                    : '-',
                status: (
                    <Badge
                        size="xl"
                        w="full"
                        textAlign="center"
                        colorScheme={colorBadge[status]}
                        color={colorBadgeFont[status]}
                        textTransform="initial"
                    >
                        {status === 'PROCESSADO'
                            ? 'Finalizado'
                            : formatter.firstLatterUppercase(status)}
                    </Badge>
                )
            })
        )
    }
    const [table, setTable] = useState<TableBuildProps<TableTypeLote>>({
        header: header as any,
        action: [
            {
                type: 'DOWNLOADLOTE',
                propsTooltip: {
                    hasArrow: true,
                    label: (
                        <Text textAlign="center" padding="0 0.4rem">
                            Clique para visualizar e fazer o download do arquivo
                            original de lotes.
                        </Text>
                    ),
                    placement: 'left',
                    children: null
                },
                disableTooltip: false
            },
            {
                type: 'RETURNFILE',
                propsTooltip: {
                    hasArrow: true,
                    label: (
                        <Text textAlign="center" padding="0 0.4rem">
                            Clique para fazer o download do arquivo de retorno.
                            O arquivo de retorno possui todas as falhas no
                            preenchimento de dados.
                        </Text>
                    ),
                    placement: 'left',
                    children: null
                },
                disableTooltip: false
            }
        ]
    })

    const formatBlob = (isContract: boolean, res: any) => {
        const base64 = res.data
        let blob
        if (isContract) {
            blob = new Blob([base64], {
                type: res.headers.contentType
            })
        } else {
            const byteCharacters = atob(base64 as string)
            const byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            const byteArray = new Uint8Array(byteNumbers)
            blob = new Blob([byteArray], {
                type: 'application/zip'
            })
        }

        return blob
    }

    const handleAction = (type: TableBuildActionsType, id: number | string) => {
        switch (type) {
            case 'DOWNLOADLOTE':
                getLoteFile(id as string, 'PREVIEW', indexTab)
                    .then(res => {
                        const isContract = indexTab === 1
                        const filenameContract = res.headers[
                            'content-disposition'
                        ]
                            ? res.headers['content-disposition'].split(
                                  'filename='
                              )[1] +
                              `${
                                  res.headers['content-type'] === 'text/csv'
                                      ? '.csv'
                                      : '.txt'
                              }`
                            : 'arquivoLote'

                        const blob = formatBlob(isContract, res)
                        const filename = isContract
                            ? filenameContract
                            : res.headers['content-disposition'].split(
                                  'filename='
                              )[1]
                        const urlFile = window.URL.createObjectURL(blob)
                        const link = document.createElement('a')
                        link.href = urlFile
                        link.setAttribute('download', filename)
                        document.body.appendChild(link)
                        link.click()
                        link.parentNode?.removeChild(link)
                    })
                    .catch(() => {
                        toast({
                            title: 'Sentimos muito!',
                            description:
                                'Ocorreu um erro, tente novamente mais tarde.',
                            position: 'bottom-left',
                            status: 'error',
                            isClosable: true
                        })
                    })
                break
            case 'RETURNFILE':
                getLoteFile(id as string, 'DOWNLOAD', indexTab)
                    .then(res => {
                        const blob = new Blob([res.data], {
                            type: res.headers.contentType
                        })

                        const filename =
                            res.headers['content-disposition'].split(
                                'filename='
                            )[1]

                        const urlFile = window.URL.createObjectURL(blob)

                        const link = document.createElement('a')

                        link.href = urlFile
                        link.setAttribute('download', filename)
                        document.body.appendChild(link)
                        link.click()
                        link.parentNode?.removeChild(link)
                    })
                    .catch(() => {
                        toast({
                            title: 'Sentimos muito!',
                            description:
                                'Ocorreu um erro, tente novamente mais tarde.',
                            position: 'bottom-left',
                            status: 'error',
                            isClosable: true
                        })
                    })
                break
        }
    }

    useEffect(() => {
        setTable(old => ({
            ...old,
            body: dataLote.length ? buildTable(dataLote) : []
        }))
    }, [dataLote])

    return (
        <>
            <TableBuild
                header={table.header}
                body={table.body}
                ordenation={orderBy}
                action={table.action}
                loading={{
                    status: loadingLote,
                    loader: [
                        {
                            height: '20px'
                        },
                        {
                            height: '20px'
                        },
                        {
                            height: '20px'
                        },
                        {
                            height: '20px'
                        },
                        {
                            height: '20px'
                        },
                        {
                            height: '20px'
                        },
                        {
                            height: '20px'
                        }
                    ]
                }}
                pagination={{
                    page,
                    limit,
                    totalPages: pageNumber
                }}
                // onOrderBy={order =>
                //     handleOrderBy(order as unknown as TableTypeLote)
                // }
                onAction={handleAction}
                onChangePage={handlePageLote}
                onChangeLimit={handleLimitLote}
            />
        </>
    )
}
